module.exports = __webpack_public_path__ + "img/reception.f71ac18a.jpeg";